import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle, faFilter } from '@fortawesome/free-solid-svg-icons';

const QuotaSummary = ({ project, calculator, onFilterChange }) => {
  if (!calculator) return <div className="quota-summary-loading">Chargement...</div>;

  const summary = calculator.getOverallSummary();
  const allBreakdowns = calculator.getAllDimensionsBreakdown();

  return (
    <div className="quota-summary">
      {/* Overall Summary */}
      <div className="summary-section">
        <h3>Répartition des Quotas</h3>
        <div className="summary-stats">
          <div className="stat-item">
            <label>Objectif global</label>
            <span className="stat-value">{summary.overallTarget.toLocaleString()}</span>
          </div>
          <div className="stat-item">
            <label>Alloué</label>
            <span className="stat-value">{summary.totalAllocated.toLocaleString()}</span>
          </div>
          <div className="stat-item">
            <label>Non alloué</label>
            <span className={`stat-value ${summary.remaining < 0 ? 'negative' : ''}`}>
              {summary.remaining.toLocaleString()}
            </span>
          </div>
          <div className="stat-item">
            <label>% Alloué</label>
            <span className="stat-value">{summary.percentageAllocated.toFixed(1)}%</span>
          </div>
        </div>
        <p style={{ fontSize: '11px', color: '#666', margin: '8px 0 4px', fontStyle: 'italic' }}>
          Progression de l'allocation des quotas aux cellules
        </p>
        <div className="progress-bar-container">
          <div 
            className="progress-bar"
            style={{ width: `${Math.min(100, summary.percentageAllocated)}%` }}
          />
        </div>
      </div>

      {/* Per-Dimension Breakdown */}
      <div className="summary-section">
        <h3>Par Dimension</h3>
        {allBreakdowns.map(({ dimension, breakdown }) => {
          if (!breakdown) return null;
          return (
            <div key={dimension.id} className="dimension-breakdown">
              <h4>{dimension.label}</h4>
              <div className="breakdown-values">
                {breakdown.breakdown.map((item) => (
                  <div 
                    key={item.code} 
                    className="breakdown-item"
                    onClick={() => onFilterChange(dimension.id, item.code)}
                  >
                    <div className="breakdown-label">
                      <FontAwesomeIcon icon={faFilter} className="filter-icon" />
                      {item.label}
                    </div>
                    <div className="breakdown-stats">
                      <span className="breakdown-allocated">
                        {item.allocated.toLocaleString()}
                      </span>
                      <span className="breakdown-current">
                        ({item.current.toLocaleString()})
                      </span>
                    </div>
                  </div>
                ))}
              </div>
              <div className="breakdown-total">
                Total: {breakdown.totals.allocated.toLocaleString()} / {summary.overallTarget.toLocaleString()}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default QuotaSummary;

